import React, { useState } from 'react';
import { CheckCircle, Copy, Download } from 'lucide-react';

export default function GeneratedMailResult({ text, onChange, platformDescription, jobId }) {
  const [copied, setCopied] = useState(false);
  const [copyError, setCopyError] = useState('');
  const count = Array.from(text).length;
  const invalid = !text.trim() || (platformDescription && count > 999);
  const label = platformDescription ? 'Description pour plateforme' : 'Generated Email';

  const copy = async () => {
    if (invalid) return;
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setCopyError('');
    } catch {
      setCopied(false);
      setCopyError('Copie impossible. Sélectionnez le texte ou téléchargez-le.');
    }
  };
  const download = () => {
    if (invalid) return;
    const url = URL.createObjectURL(new Blob([text], { type: 'text/plain' }));
    const link = document.createElement('a');
    link.href = url;
    link.download = `${platformDescription ? 'description_plateforme' : 'recruitment_email'}_${jobId}.txt`;
    link.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <label htmlFor="generated-mail" className="text-lg font-semibold text-gray-900">{label}</label>
        <div className="flex space-x-2">
          <button onClick={copy} disabled={invalid} className="min-h-[44px] px-3 py-2 bg-blue-600 text-white rounded-lg disabled:opacity-50 focus:ring-2 focus:ring-purple-500">
            {copied ? <CheckCircle size={14} /> : <Copy size={14} />}{copied ? 'Copied!' : 'Copy'}
          </button>
          <button onClick={download} disabled={invalid} className="min-h-[44px] px-3 py-2 bg-green-600 text-white rounded-lg disabled:opacity-50 focus:ring-2 focus:ring-purple-500">
            <Download size={14} />Download
          </button>
        </div>
      </div>
      <textarea id="generated-mail" value={text} onChange={e => { onChange(e.target.value); setCopied(false); }}
        aria-describedby={platformDescription ? 'description-count' : undefined} aria-invalid={invalid}
        className="w-full h-96 p-4 border border-gray-300 rounded-lg resize-none focus:ring-2 focus:ring-purple-500" />
      {platformDescription && <p id="description-count" aria-live="polite" className="text-sm text-gray-700">
        {count} / 999 caractères (espaces et sauts de ligne inclus)
      </p>}
      {invalid && <p role="alert" className="text-sm text-red-600">
        {text.trim() ? 'Maximum 999 caractères : raccourcissez la description avant de copier ou télécharger.' : 'Saisissez un texte avant de copier ou télécharger.'}
      </p>}
      {copyError && <p role="alert" className="text-sm text-red-600">{copyError}</p>}
    </div>
  );
}
